;(function (b, a, e, h, f, c, g, s) {
  try {
    b[h] =
      b[h] ||
      function () {
        (b[h].c = b[h].c || []).push(arguments);
      };
    b[h].s = !!c;
    g = a.getElementsByTagName(e)[0];
    s = a.createElement(e);
    s.src = "//s.union.360.cn/" + f + ".js";
    s.defer = !0;
    s.async = !0;
    g.parentNode.insertBefore(s, g);
  } catch (error) {
    console.log(error);
  }
})(window, document, "script", "_qha", 315440, false);
